import template from './promote_demote_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class PromoteDemoteHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class PromoteDemoteHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new PromoteDemoteHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'PromoteDemoteHelp',
	dialog_class: PromoteDemoteHelpPage,
	template: template,
	template_filename: 'translation/dialogs/promote_demote_help',
	provider: 'ps'
};
